// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reactions-panel-wrapper .reactions-panel[data-v-cddf845a] {
  z-index: 9999;
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 300px;
  height: fit-content;
  border-radius: 0.5em;
  background-color: var(--context-bgcolor);
  color: var(--context-color);
  box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.14), -1px -1px 0px 0 rgba(57, 57, 57, 0.1);
  font-size: 1.25rem;
  overflow-y: auto;
}
.reactions-panel-wrapper .reactions-panel .reactions-panel-header[data-v-cddf845a] {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 1.25rem;
  padding: 0 0.1em 0.25em 0.8em;
}
.reactions-panel-wrapper .reactions-panel .reactions-panel-header .total-reactions[data-v-cddf845a] {
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 1.45rem;
  padding: 0.5em;
  border-radius: 0.8em;
  cursor: pointer;
}
.reactions-panel-wrapper .reactions-panel .reactions-panel-header .total-reactions.active[data-v-cddf845a] {
  background-color: var(--reactions-panel-totalbgcolor);
}
.reactions-panel-wrapper .reactions-panel .reactions-panel-header .total-reactions[data-v-cddf845a]:hover {
  background-color: var(--reactions-panel-totalbgcolor);
  border-radius: 0.7em;
}
.reactions-panel-wrapper .reactions-panel .reactions-panel-header .header-reaction[data-v-cddf845a] {
  display: flex;
  margin-left: 0.25em;
  height: 100%;
  align-items: center;
  padding: 0.5em;
  border-radius: 0.8em;
  cursor: pointer;
}
.reactions-panel-wrapper .reactions-panel .reactions-panel-header .header-reaction .reaction-item[data-v-cddf845a] {
  display: flex;
  align-items: center;
  height: 100%;
}
.reactions-panel-wrapper .reactions-panel .reactions-panel-header .header-reaction.active[data-v-cddf845a] {
  background-color: var(--reactions-panel-totalbgcolor);
}
.reactions-panel-wrapper .reactions-panel .reactions-panel-header .header-reaction[data-v-cddf845a]:hover {
  background-color: var(--reactions-panel-totalbgcolor);
  border-radius: 0.7em;
}
.reactions-panel-wrapper .reactions-panel .reactions-panel-header .header-reaction .reaction-count[data-v-cddf845a] {
  margin-left: 0.3em;
  font-size: 1.45rem;
}
.reactions-panel-wrapper .reactions-panel .reactions-panel-body .contact-wrapper[data-v-cddf845a] {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.reactions-panel-wrapper .reactions-panel .reactions-panel-body .contact-wrapper .reaction-item[data-v-cddf845a] {
  font-size: 1.45rem;
  padding-right: 1rem;
  pointer-events: none;
}
.v-enter-active[data-v-cddf845a],
.v-leave-active[data-v-cddf845a] {
  transition: opacity 0.5s ease;
}
.v-enter-from[data-v-cddf845a],
.v-leave-to[data-v-cddf845a] {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/reactions/ReactionsPanel.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,2BAA2B;EAC3B,sFAAsF;EACtF,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;EACrD,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;EACrD,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,UAAU;AACZ","sourcesContent":[".reactions-panel-wrapper .reactions-panel[data-v-cddf845a] {\n  z-index: 9999;\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  width: 300px;\n  height: fit-content;\n  border-radius: 0.5em;\n  background-color: var(--context-bgcolor);\n  color: var(--context-color);\n  box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.14), -1px -1px 0px 0 rgba(57, 57, 57, 0.1);\n  font-size: 1.25rem;\n  overflow-y: auto;\n}\n.reactions-panel-wrapper .reactions-panel .reactions-panel-header[data-v-cddf845a] {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  font-size: 1.25rem;\n  padding: 0 0.1em 0.25em 0.8em;\n}\n.reactions-panel-wrapper .reactions-panel .reactions-panel-header .total-reactions[data-v-cddf845a] {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  font-size: 1.45rem;\n  padding: 0.5em;\n  border-radius: 0.8em;\n  cursor: pointer;\n}\n.reactions-panel-wrapper .reactions-panel .reactions-panel-header .total-reactions.active[data-v-cddf845a] {\n  background-color: var(--reactions-panel-totalbgcolor);\n}\n.reactions-panel-wrapper .reactions-panel .reactions-panel-header .total-reactions[data-v-cddf845a]:hover {\n  background-color: var(--reactions-panel-totalbgcolor);\n  border-radius: 0.7em;\n}\n.reactions-panel-wrapper .reactions-panel .reactions-panel-header .header-reaction[data-v-cddf845a] {\n  display: flex;\n  margin-left: 0.25em;\n  height: 100%;\n  align-items: center;\n  padding: 0.5em;\n  border-radius: 0.8em;\n  cursor: pointer;\n}\n.reactions-panel-wrapper .reactions-panel .reactions-panel-header .header-reaction .reaction-item[data-v-cddf845a] {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n.reactions-panel-wrapper .reactions-panel .reactions-panel-header .header-reaction.active[data-v-cddf845a] {\n  background-color: var(--reactions-panel-totalbgcolor);\n}\n.reactions-panel-wrapper .reactions-panel .reactions-panel-header .header-reaction[data-v-cddf845a]:hover {\n  background-color: var(--reactions-panel-totalbgcolor);\n  border-radius: 0.7em;\n}\n.reactions-panel-wrapper .reactions-panel .reactions-panel-header .header-reaction .reaction-count[data-v-cddf845a] {\n  margin-left: 0.3em;\n  font-size: 1.45rem;\n}\n.reactions-panel-wrapper .reactions-panel .reactions-panel-body .contact-wrapper[data-v-cddf845a] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.reactions-panel-wrapper .reactions-panel .reactions-panel-body .contact-wrapper .reaction-item[data-v-cddf845a] {\n  font-size: 1.45rem;\n  padding-right: 1rem;\n  pointer-events: none;\n}\n.v-enter-active[data-v-cddf845a],\n.v-leave-active[data-v-cddf845a] {\n  transition: opacity 0.5s ease;\n}\n.v-enter-from[data-v-cddf845a],\n.v-leave-to[data-v-cddf845a] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
